import { forwardRef } from 'react';

export const Input = forwardRef(function Input(
    { label, hint, error, className = '', mono = false, ...rest },
    ref
) {
    return (
        <label className="block">
            {label && (
                <span className="block text-xs font-medium text-ink-700 mb-1.5 uppercase tracking-wide">
                    {label}
                </span>
            )}
            <input
                ref={ref}
                className={[
                    'w-full px-3 py-2 bg-white border border-cream-300 rounded-md text-sm text-ink-900',
                    'placeholder:text-ink-300 transition',
                    'focus:outline-none focus:border-accent-500 focus:ring-2 focus:ring-accent-500/15',
                    error ? 'border-danger-500' : '',
                    mono ? 'font-mono' : '',
                    className,
                ].filter(Boolean).join(' ')}
                {...rest}
            />
            {hint && !error && (
                <span className="block text-xs text-ink-400 mt-1">{hint}</span>
            )}
            {error && (
                <span className="block text-xs text-danger-500 mt-1">{error}</span>
            )}
        </label>
    );
});
